import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const usePendoPageTracking = () => {
  const location = useLocation()

  useEffect(() => {
    const isPendoReady =
      typeof window !== 'undefined' && typeof window.pendo?.pageLoad === 'function'

    if (!isPendoReady) {
      console.warn('Pendo is not available yet')
      return
    }

    try {
      window.pendo.pageLoad()
    } catch (err) {
      console.error('Pendo pageLoad error:', err)
    }
  }, [location.pathname])
}

export default usePendoPageTracking
